import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LinqChartData } from './linq-chart-data';
import { OrganisationService } from '../organisation/organisation.service';
import { DEFAULT_CURRENCY } from '../common/organisation';

@Component({
  selector: 'app-chart-legend',
  templateUrl: 'legend.html',
  styleUrl: 'legend.css',
  standalone: false
})
export class LegendComponent implements OnChanges, AfterViewInit {
    @Input() title:string
    @Input() data:LinqChartData[]
    @Input() isCurrency:boolean
    @Input() trigger:any

    total:number
    currencyCode:string

    constructor(private organisationService:OrganisationService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.currencyCode = this.organisationService.organisation?.currencyCode||DEFAULT_CURRENCY
        
        this.setupData()
    }
    ngAfterViewInit(): void {
        this.setupData()
    }

    setupData() {
        this.total = this.data.reduce((t, d) => {
            t += d.value
            return t
        }, 0)
    }

    getPercentage(d:LinqChartData) {
        return this.total?Math.round(100*d.value/this.total) + '%':'0%'
    }
    
}